<template>
  <scoped>
    <table v-if="items">
      <thead>
        <tr>
          <th>
            Name
          </th>
        </tr>
      </thead>
      <tbody v-if="items.length > 0">
        <tr
          v-for="(supplier, index) in items"
          :key="supplier.id"
          :class="{'selected' : selectedIndex == index}"
          @click="select(index)"
        >
          <td>
            {{ supplier.name }}
          </td>
        </tr>
      </tbody>
    </table>
  </scoped>
</template>

<script setup lang="ts">
  import {Supplier} from "@/endpoints/rutsolve/gql/generated/graphql"
  import {nextTick} from "vue"

  defineProps({
    items: {
      default: null,
      required: true,
      type: Array<Supplier>
    }
  })

  const emits = defineEmits([
    "select",
  ])

  const selectedIndex = defineModel("selectedIndex", {
    default: null,
    required: false,
    type: Number
  })

  async function select(index: number) {
    selectedIndex.value = index
    await nextTick()
    emits("select")
  }
</script>

<style scoped>
  table {
    > tbody {
      > tr {
        &:hover {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: pointer;
        }
        
        &.selected {
          background-color: var(--theme-color-secondary);
          color: var(--color-white);
          cursor: default;
        }
      }
    }
  }
</style>
